import { isWhitelistedAdminEmail } from '../constants/adminAccess';

const DEV_SETTINGS_ROLES = new Set(['owner', 'developer']);

export type DevSettingsAuth = {
  user?: { email?: string | null } | null;
  adminRole?: string | null;
};

/** Settings → Developer (local-core dev toggle) — ops/admin only. */
export function canShowDeveloperSettings(auth: DevSettingsAuth | null | undefined): boolean {
  if (!auth) return false;
  if (isWhitelistedAdminEmail(auth.user?.email ?? undefined)) return true;
  const role = auth.adminRole;
  return !!role && DEV_SETTINGS_ROLES.has(role);
}
